import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Pricing.module.css";

const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

const Pricing = () => {
  const navigate = useNavigate();

  return (
    <section className={ styles.pricing }>
      <div className={ styles.container }>
        <h1 className={ styles.title }>Simple, Transparent pricing</h1>
        <p className={ styles.subtitle }>
          Designed for inside + field sales teams at 1/5th the cost of leading platforms
        </p>
        <div className={ styles.priceContainer }>
          <p className={ styles.price }>Starting from ₹1,899/user/month</p>
        </div>
        <div className={ styles.ctaContainer }>
          <p className={ styles.ctaText }>
            Click to see full pricing{ " " }
            <button onClick={ () => navigate('/pricing') } className={ styles.contactButton }>Pricing</button>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;